import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";
import { useBrand, BrandLogo, brandName, PoweredBy } from "@/components/Brand";
import { bizSlug, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthShell = ({ children, right, testId }) => (
  <div className="auth" data-testid={testId}>
    <header className="auth-nav" data-testid="auth-nav">
      <Link to="/" className="auth-logo" data-testid="auth-logo"><span className="spottr-mark" style={{ width: 32, height: 32 }}><Zap size={18} strokeWidth={2.8} fill="currentColor" /></span><b>SpottrOS</b></Link>
      <nav>{right}</nav>
    </header>
    {children}
  </div>
);

export default function Login() {
  const brand = useBrand();
  const biz = bizSlug();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(email, password);
      nav(u.role === "ADMIN" ? "/admin" : "/client", { replace: true });
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthShell testId="login-page" right={<><Link to="/signup" data-testid="login-signup-link">Start free trial</Link><Link to="/" data-testid="login-landing-link">spottr-os.com</Link></>}>
      <div className="login fade">
        {biz ? (
          <div className="brand" style={{ marginBottom: 18 }} data-testid="login-home-link">
            <BrandLogo brand={brand} size={40} testId="login-brand-logo" />
            <div><b style={{ fontSize: 17 }} data-testid="login-brand-name">{brandName(brand).toUpperCase()}</b><small>CLIENT PORTAL · POWERED BY SPOTTROS</small></div>
          </div>
        ) : (
          <div className="brand" style={{ marginBottom: 18 }} data-testid="login-home-link">
            <span className="spottr-mark" style={{ width: 40, height: 40 }} data-testid="login-brand-logo"><Zap size={22} strokeWidth={2.8} fill="currentColor" /></span>
            <div><b style={{ fontSize: 17 }} data-testid="login-brand-name">SPOTTROS</b><small>TRAINER OS</small></div>
          </div>
        )}
        <span className="auth-kick">Welcome back</span>
        <h1>Sign <em>in.</em></h1>
        <p>{biz ? `Your sessions, programs and progress at ${brandName(brand)}.` : "Run your whole coaching business from one dark, fast console."}</p>
        <form onSubmit={submit}>
          <label htmlFor="email">Email</label>
          <input id="email" data-testid="login-email-input" type="email" required placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          <label htmlFor="password">Password</label>
          <input id="password" data-testid="login-password-input" type="password" required placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} />
          <div style={{ marginTop: 22 }}>
            <button className="btn" style={{ width: "100%", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8 }} disabled={busy} data-testid="login-submit-button">{busy ? "Entering…" : "Sign in"} {!busy && <ArrowRight size={16} />}</button>
          </div>
          {err && <div className="err" data-testid="login-error">{err}</div>}
        </form>
        {!biz && <p className="ss" style={{ marginTop: 16, marginBottom: 0 }} data-testid="login-demo-hint">Demo · coach@demofitness.co or sarah.mendes@example.com · password123</p>}
        <p className="ss" style={{ textAlign: "center", marginTop: 14, marginBottom: 0 }}>New here? <Link to="/signup" data-testid="login-signup-link-bottom" style={{ color: "var(--accent)" }}>Start your free trial</Link></p>
        {biz && <PoweredBy />}
      </div>
    </AuthShell>
  );
}
